import React from 'react';
import { Card, Col, Row } from 'antd';

const CBLConditions = () => {
    return (
        <div className="quote-content break-page" style={{ marginTop: '40px' }}>
            <Row gutter={[20, 20]}>
                <Col xs={24}>
                    <Card title={'Charter Conditions - CBL'} className="card-main card-info page-break-inside-avoid quote-conditions">
                        <div className="quote-conditions-content">
                            <p>We want your trip to be safe, comfortable, and stress-free. Please take note of our charter conditions:</p>
                            
                            <div className="quote-conditions-item">
                                <h4>Booking & Payment</h4>
                                <ul>
                                    <li>Written confirmation will be provided once everything is set. No charter is booked without a booking confirmation from CBL</li>
                                </ul>
                            </div>

                            <div className="quote-conditions-item">
                                <h4>Cancellations</h4>
                                <ul>
                                <li>We reserve the right to charge a cancellation fee for bookings cancelled within 24 Hours of Travel.</li>
                                <li>The company reserves the right to cancel a charter due to unforeseen circumstances (e.g., extreme weather, safety concerns). In such cases, a full refund will be issued.</li>
                                </ul>
                            </div>

                            <div className="quote-conditions-item">
                                <h4>Vehicles & Routes</h4>
                                <ul>
                                    <li>Vehicles may be substituted with similar or larger models if needed.</li>
                                    <li>The charter driver may change or alter routes based on road conditions or safety concerns.</li>
                                </ul>
                            </div>

                            <div className="quote-conditions-item">
                                <h4>Passenger Conduct</h4>
                                <ul>
                                    <li>No smoking, alcohol, or illegal substances on board.</li>
                                    <li>Any damage to the vehicle or excess litter caused by passengers will be charged to the chartering party.</li>
                                    <li>Seatbelts must be worn where fitted.</li>
                                </ul>
                            </div>

                            <div className="quote-conditions-item">
                                <h4>Luggage</h4>
                                <ul>
                                    <li>Luggage allowance will be agreed in advance. Oversized or excess baggage may be refused.</li>
                                    <li>Hazardous, flammable, or illegal items are not permitted.</li>
                                </ul>
                            </div>

                            <div className="quote-conditions-item">
                                <h4>Delays & Waiting</h4>
                                <ul>
                                    <li>CBL shall not be liable for delays caused by traffic, weather, mechanical issues, or events beyond its control.</li>
                                    <li>Extra waiting time beyond the agreed schedule may be charged at the rate of $120/Hour.</li>
                                </ul>
                            </div>

                            <div className='quote-conditions-item'>
                                <h4>Responsibility</h4>
                                <ul>
                                    <li>CBL is not responsible for loss, damage, or theft of personal belongings.</li>
                                </ul>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default React.memo(CBLConditions);
